import { createApi } from '@reduxjs/toolkit/query/react';

import {
  SalaryCertificateFormPostRequest,
  HrmRequestFormResponse,
} from '@Types/api/form';
import {
  RequestListSearchRequest,
  RequestListSearchResponse,
} from '@Types/api/requestList';
import { ApiBaseName, ApiReducerPath, RequestTypeCodes } from '@Enum/index';
import { PAGE_SIZE, TABLE_PAGE_DEFAULT } from '@Features/constants';
import { customBaseQuery } from '@Utils/api/customBaseQuery';

const REQ_TYPE_FILTER = {
  name: 'requestTypeID',
  value: RequestTypeCodes.SALARY_CERTIFICATE,
  operator: 'eq',
};

export const salaryCertificateApi = createApi({
  tagTypes: ['salaryCertificate'],
  reducerPath: ApiReducerPath.API_SALARY_CERTIFICATE,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getSalaryCertificates: builder.mutation<
      RequestListSearchResponse<HrmRequestFormResponse>,
      RequestListSearchRequest
    >({
      query: ({
        searchValue,
        filters = [],
        page = TABLE_PAGE_DEFAULT,
        size = PAGE_SIZE,
        sortBy = 'requestId',
        sortOrder = 'desc',
      }) => ({
        url: `${ApiBaseName.ESS}/hrm-request/search`,
        method: 'post',
        body: {
          searchValue,
          searchCriteriaList: [
            {
              searchCriterias: [...filters, REQ_TYPE_FILTER],
              dataOperator: 'and',
            },
          ],
          dataOperator: 'and',
        },
        params: { page, size, 'sort-by': sortBy, 'sort-order': sortOrder },
      }),
    }),
    postSalaryForm: builder.mutation<
      HrmRequestFormResponse,
      SalaryCertificateFormPostRequest
    >({
      query: (body) => ({
        url: `${ApiBaseName.ESS}/hrm-request`,
        method: 'post',
        body: {
          ...body,
          requestTypeID: RequestTypeCodes.SALARY_CERTIFICATE,
        },
      }),
      invalidatesTags: ['salaryCertificate'],
    }),
    formValidation: builder.mutation<
      HrmRequestFormResponse,
      SalaryCertificateFormPostRequest
    >({
      query: (body) => ({
        url: `${ApiBaseName.ESS}/hrm-request/validate`,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const {
  usePostSalaryFormMutation,
  useFormValidationMutation,
  useGetSalaryCertificatesMutation,
} = salaryCertificateApi;
